module.exports = __webpack_public_path__ + "media/images/web/home/index/header_bg-71a7863eefd35fedeeca6452c8cc6484.webp";